export function getCoins() {
  return ['btc', 'eth', 'usdt', 'usdc'];
}

export type Coin = {
  name: string;
  ticker: string;
};

export type CoinBadge = {
  slug: string;
  ticker: string;
};

export const coinData: Record<string, Coin> = {
  aave: { name: 'Aave', ticker: 'AAVE' },
  ada: { name: 'Cardano', ticker: 'ADA' },
  algo: { name: 'Algorand', ticker: 'ALGO' },
  ape: { name: 'ApeCoin', ticker: 'APE' },
  apt: { name: 'AptCoin', ticker: 'APT' },
  arb: { name: 'Arbitrum', ticker: 'ARB' },
  atom: { name: 'Cosmos', ticker: 'ATOM' },
  avax: { name: 'Avalanche', ticker: 'AVAX' },
  axs: { name: 'Axie Infinity', ticker: 'AXS' },
  bch: { name: 'Bitcoin Cash', ticker: 'BCH' },
  blz: { name: 'Bluzelle', ticker: 'BLZ' },
  btc: { name: 'Bitcoin', ticker: 'BTC' },
  chz: { name: 'Chiliz', ticker: 'CHZ' },
  comp: { name: 'Compound', ticker: 'COMP' },
  crv: { name: 'Curve DAO Token', ticker: 'CRV' },
  dai: { name: 'Dai', ticker: 'DAI' },
  shib: { name: 'Shiba Inu', ticker: 'SHIB' },
  dash: { name: 'Dash', ticker: 'DASH' },
  doge: { name: 'Dogecoin', ticker: 'DOGE' },
  dot: { name: 'Polkadot', ticker: 'DOT' },
  eos: { name: 'EOS.IO', ticker: 'EOS' },
  etc: { name: 'Ethereum Classic', ticker: 'ETC' },
  eth: { name: 'Ethereum', ticker: 'ETH' },
  fet: { name: 'Fetch.ai', ticker: 'FET' },
  fil: { name: 'Filecoin', ticker: 'FIL' },
  ftm: { name: 'Fantom', ticker: 'FTM' },
  gala: { name: 'Gala Games', ticker: 'GALA' },
  gal: { name: 'Galatasaray Fan Token', ticker: 'GAL' },
  grt: { name: 'The Graph', ticker: 'GRT' },
  hbar: { name: 'Hedera Hashgraph', ticker: 'HBAR' },
  icp: { name: 'Internet Computer', ticker: 'ICP' },
  inj: { name: 'Injective Protocol', ticker: 'INJ' },
  knc: { name: 'Kyber Network', ticker: 'KNC' },
  snx: { name: 'Synthetix', ticker: 'SNX' },
  ldo: { name: 'Lido DAO', ticker: 'LDO' },
  link: { name: 'Chainlink', ticker: 'LINK' },
  ltc: { name: 'Litecoin', ticker: 'LTC' },
  luna: { name: 'Terra', ticker: 'LUNA' },
  mana: { name: 'Decentraland', ticker: 'MANA' },
  mask: { name: 'Mask Network', ticker: 'MASK' },
  matic: { name: 'Polygon', ticker: 'MATIC' },
  mkr: { name: 'Maker', ticker: 'MKR' },
  near: { name: 'NEAR Protocol', ticker: 'NEAR' },
  nmr: { name: 'Numeraire', ticker: 'NMR' },
  oxt: { name: 'Orchid', ticker: 'OXT' },
  qtum: { name: 'Qtum', ticker: 'QTUM' },
  rndr: { name: 'Render Token', ticker: 'RNDR' },
  runethor: { name: 'RuneThor', ticker: 'RUNETHOR' },
  sand: { name: 'The Sandbox', ticker: 'SAND' },
  sol: { name: 'Solana', ticker: 'SOL' },
  spell: { name: 'Spell Token', ticker: 'SPELL' },
  storj: { name: 'Storj', ticker: 'STORJ' },
  stx: { name: 'Stacks', ticker: 'STX' },
  sui: { name: 'Sushiswap', ticker: 'SUI' },
  syn: { name: 'Synthetify', ticker: 'SYN' },
  trx: { name: 'TRON', ticker: 'TRX' },
  tusd: { name: 'TrueUSD', ticker: 'TUSD' },
  unfi: { name: 'Uniswap Finance', ticker: 'UNFI' },
  uni: { name: 'Uniswap', ticker: 'UNI' },
  usdc: { name: 'USD Coin', ticker: 'USDC' },
  usdt: { name: 'USD Tether', ticker: 'USDT' },
  waves: { name: 'Waves', ticker: 'WAVES' },
  wbtc: { name: 'Wrapped Bitcoin', ticker: 'WBTC' },
  xlm: { name: 'Stellar', ticker: 'XLM' },
  xmr: { name: 'Monero', ticker: 'XMR' },
  xrp: { name: 'XRP', ticker: 'XRP' },
  zecz: { name: 'Zcash', ticker: 'ZECZ' },
};

export const coinBadges: CoinBadge[] = Object.entries(coinData).map(([slug, { ticker }]) => ({
  slug,
  ticker,
}));
